import React, { useEffect } from "react";
import { BsCheckCircle } from "react-icons/bs";
import Link from "next/link";
import Title from "~/shared/Title";
import Button from "~/shared/Btn";
import { SuccessContainer, SuccessMessage, Footer } from "./styles";
import Head from "next/head";

type SuccessProps = {
    content: string;
    hrefButton?: string;
}

const Success = ({content, hrefButton}:SuccessProps) => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Head>
                <title>Solicitação publicada - Fotop Serviços</title>
            </Head>
            <SuccessMessage>
                <Title featured level="1">Job agendado com sucesso!</Title>
            </SuccessMessage>
            <SuccessContainer>
                <BsCheckCircle size={72} color="#0DD735" />
                <p>{content}</p>
            </SuccessContainer>

            <Footer>
                <Link href={ hrefButton ? hrefButton : `/dashboard`}>
                    <Button block style={{ maxWidth: "33.875rem" }}>
                        <a style={{ color: "inherit", textDecoration: "none" }}>{ hrefButton ? "Retornar a página inicial" : "Retornar ao dashboard"}</a>
                    </Button>
                </Link>
            </Footer>
        </>
    );
};

export default Success;
